import type { FunctionComponent, SVGProps } from "react"

import Hand1 from "@/assets/svg/palmistry/result/hand1.svg?react"
import Hand2 from "@/assets/svg/palmistry/result/hand2.svg?react"
import Hand3 from "@/assets/svg/palmistry/result/hand3.svg?react"
import Hand4 from "@/assets/svg/palmistry/result/hand4.svg?react"
import Hand5 from "@/assets/svg/palmistry/result/hand5.svg?react"
import Hand6 from "@/assets/svg/palmistry/result/hand6.svg?react"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

export interface PalmSlide {
  title: string
  Icon: SvgComponent
  /** Fixed labels; the first two slides instead derive labels from the user's astrology. */
  labels?: string[]
  /** Pull labels from the zodiac's strong / weak sides. */
  source?: "strong" | "weak"
}

/** "What your hand reveals" carousel cards. Ported from ResultPalmReading.config slides. */
export const palmSlides: PalmSlide[] = [
  { title: "Highlights of Your Nature", Icon: Hand1, source: "strong" },
  { title: "Challenges in Your Lines", Icon: Hand2, source: "weak" },
  {
    title: "Traits of the Life Line",
    Icon: Hand3,
    labels: [
      "Energetic",
      "Anxious under pressure",
      "Needs routine",
      "Risk-averse",
      "Strong-willed",
      "Emotionally guarded",
      "Overcommitted",
    ],
  },
  {
    title: "Voice of the Head Line",
    Icon: Hand4,
    labels: [
      "Overthinking",
      "Self-critical",
      "Analytical",
      "Emotionally detached",
      "Judgmental",
      "Intellect-driven",
      "Resistant to advice",
    ],
  },
  {
    title: "Essence of the Heart Line",
    Icon: Hand5,
    labels: [
      "Sensitive but withdrawn",
      "Avoids emotional risks",
      "Craves deep connection",
      "Struggles to forgive",
      "Prone to jealousy",
      "Emotionally intense",
    ],
  },
  {
    title: "What Special Marks Say",
    Icon: Hand6,
    labels: [
      "Feels misunderstood",
      "Quietly ambitious",
      "Emotionally layered",
      "Holds onto the past",
      "High inner expectations",
      "Needs space",
    ],
  },
]
